module.exports = __WEBPACK_EXTERNAL_MODULE_32__;


//////////////////
// WEBPACK FOOTER
// external "gemini/lib/@waca/dashboard-common/dist/ui/AuthoringToolbar"
// module id = 32
// module chunks = 1